import { useLocation } from 'react-router-dom';
import {
    ENVIROS_WHERE_CONNECT_MLS_IS_HIDDEN,
    ENVIROS_WHERE_TREND_ANALYSIS_IS_HIDDEN,
    getIsConnectMlsEnabled, getIsDashboardEnabled, getIsNotificationsEnabled,
    getIsTrendAnalysisDebugEnabled,
    isComparisonSetsEnabled,
    pdfDisabledRoutes,
    pdfUnderConstructionModules,
    getIsInternalAccount,
    IS_TALENT_LINK_ENABLED
} from '../helpers/featureToggles';
import { useAuthStore } from '../../store/auth/store';
import { useCommonStore, useSearchStore } from '../../store/store';
import { isAgentMetrics } from '../../constants/app';

export const useFeatureToggles = () => {
    const selectedModule = useSearchStore(state => state.selectedModule);
    const currentPath = useLocation().pathname;
    const email = useAuthStore(state => state.tokenInfo?.email);
    const isConnectMlsEnabled = getIsConnectMlsEnabled({
        isAgentMetrics,
        hostname: location.hostname,
        email,
        envirosWhereIsHidden: ENVIROS_WHERE_CONNECT_MLS_IS_HIDDEN
    });

    const { id: accountId } = useCommonStore(state => state.accountInfo || {});
    const isDashboardEnabled = getIsDashboardEnabled(isAgentMetrics);
    const isNotificationsEnabled = getIsNotificationsEnabled(isAgentMetrics, accountId);
    const isInternalAccount = getIsInternalAccount(accountId)

    const isTrendAnalysisDebugOutputEnabled = getIsTrendAnalysisDebugEnabled(location.hostname,
        ENVIROS_WHERE_TREND_ANALYSIS_IS_HIDDEN);

    return {
        trendAnalysisDebugOutput: {
            isEnabled: isTrendAnalysisDebugOutputEnabled
        },
        notifications: {
            isEnabled: isNotificationsEnabled
        },
        comparisonSets: {
            isEnabled: isComparisonSetsEnabled
        },
        dashboard: {
            isEnabled: isDashboardEnabled
        },
        mdOfficeBreakdown: {
            isEnabled: true
        },
        suggestedAgents: {
            isEnabled: true
        },
        agentMovement: {
            isEnabled: true
        },
        connectMls: {
            isEnabled: isConnectMlsEnabled
        },
        isPdfUnderConstruction: pdfUnderConstructionModules.includes(selectedModule) || pdfDisabledRoutes.includes(currentPath),
        agentProduction: {
            isEnabled: true
        },
        todaysPicks: {
            isEnabled: isInternalAccount
        },
        talent: {
            isEnabled: IS_TALENT_LINK_ENABLED
        },
    };
};
